export default __webpack_public_path__ + "static/media/change-link-img.2d5f626d.svg";